var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7936 3.2798C25.7936 1.65431 24.4757 0.336426 22.8503 0.336426H3.18434C1.55886 0.336426 0.240967 1.65431 0.240967 3.2798V18.1245C0.240967 19.7499 1.55886 21.0678 3.18434 21.0678H22.8503C24.4757 21.0678 25.7936 19.7499 25.7936 18.1245V3.2798Z",
    fill: "url(#paint0_linear_5054_25591)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M15.7394 14.3182H9.81364C9.1876 14.3182 8.67847 13.8091 8.67847 13.1833V8.46256C8.67847 7.83676 9.1876 7.32764 9.81364 7.32764H15.7394C16.3655 7.32764 16.8746 7.83676 16.8746 8.46256V13.1833C16.8746 13.8091 16.3655 14.3182 15.7394 14.3182ZM9.81364 7.80952C9.45349 7.80952 9.16059 8.10241 9.16059 8.46232V13.183C9.16059 13.5432 9.45349 13.8358 9.81364 13.8358H15.7394C16.0996 13.8358 16.3925 13.543 16.3925 13.183V8.46232C16.3925 8.10217 16.0996 7.80952 15.7394 7.80952H9.81364Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91933 9.49726H0.241063C0.107755 9.49726 0 9.38927 0 9.2562C0 9.12313 0.107755 9.01514 0.241063 9.01514H8.91933C9.05263 9.01514 9.16039 9.12313 9.16039 9.2562C9.16039 9.38927 9.05263 9.49726 8.91933 9.49726Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91933 11.4255H0.241063C0.107755 11.4255 0 11.3175 0 11.1844C0 11.0514 0.107755 10.9434 0.241063 10.9434H8.91933C9.05263 10.9434 9.16039 11.0514 9.16039 11.1844C9.16039 11.3175 9.05263 11.4255 8.91933 11.4255Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7938 9.49726H16.6334C16.5001 9.49726 16.3923 9.38927 16.3923 9.2562C16.3923 9.12313 16.5001 9.01514 16.6334 9.01514H25.7938C25.9271 9.01514 26.0348 9.12313 26.0348 9.2562C26.0348 9.38927 25.9271 9.49726 25.7938 9.49726Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7938 11.4255H16.6334C16.5001 11.4255 16.3923 11.3175 16.3923 11.1844C16.3923 11.0514 16.5001 10.9434 16.6334 10.9434H25.7938C25.9271 10.9434 26.0348 11.0514 26.0348 11.1844C26.0348 11.3175 25.9271 11.4255 25.7938 11.4255Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2581 7.79615C10.1489 7.79615 10.0501 7.72142 10.0238 7.61053L8.29127 0.296683C8.26041 0.166992 8.34068 0.0373047 8.47013 0.00644863C8.59838 -0.0239253 8.72952 0.0558619 8.76013 0.185554L10.4927 7.4994C10.5235 7.62909 10.4432 7.75879 10.3138 7.78964C10.2952 7.79422 10.2764 7.79615 10.2581 7.79615Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9418 7.79628C14.9228 7.79628 14.9035 7.7941 14.8842 7.78928C14.755 7.75746 14.6759 7.62705 14.7077 7.4976L16.5041 0.18375C16.5357 0.0545407 16.6668 -0.0238034 16.7956 0.00729369C16.9248 0.039114 17.0038 0.169527 16.972 0.298978L15.1756 7.61282C15.1489 7.72275 15.0503 7.79628 14.9418 7.79628Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52607 21.4614C8.50774 21.4614 8.48894 21.4592 8.47013 21.4548C8.34068 21.4242 8.26041 21.2943 8.29127 21.1646L10.0238 13.8508C10.0544 13.7211 10.1839 13.6408 10.3138 13.6716C10.4432 13.7025 10.5235 13.8322 10.4927 13.9619L8.76013 21.2757C8.7341 21.3869 8.63527 21.4614 8.52607 21.4614Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.738 21.4614C16.6297 21.4614 16.5311 21.3879 16.5041 21.2779L14.7077 13.9641C14.6759 13.8347 14.755 13.7042 14.8842 13.6724C15.0139 13.6411 15.144 13.7197 15.1756 13.8489L16.972 21.1627C17.0038 21.2922 16.9248 21.4226 16.7956 21.4544C16.7763 21.4592 16.757 21.4614 16.738 21.4614Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5054_25591",
    x1: 70.1762,
    y1: -11.0487,
    x2: 4.91585,
    y2: 13.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E92556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C342"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardChip);
export default __webpack_public_path__ + "static/media/card-chip.2980fe66e02886b5bc3ef70b3c686baf.svg";
export { ForwardRef as ReactComponent };